import { render, staticRenderFns } from "./PriSearchContainer.vue?vue&type=template&id=51359055&scoped=true"
import script from "./PriSearchContainer.vue?vue&type=script&lang=js"
export * from "./PriSearchContainer.vue?vue&type=script&lang=js"
import style0 from "./PriSearchContainer.vue?vue&type=style&index=0&id=51359055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51359055",
  null
  
)

export default component.exports